import { gsap } from 'gsap';
export default function initAnimation() {
    const spans = gsap.utils.toArray<HTMLSpanElement>('.read-text-span');

    spans.forEach((span, index) => {
        const delay = index * 0.1; // 每个元素延迟0.1秒开始

        gsap.fromTo(
            span,
            { opacity: 0.2 }, // 从完全隐藏开始
            {
                opacity: 1,
                scrollTrigger: {
                    trigger: span,
                    start: () => `top center+=${5 - delay}%`, // 延迟计算开始点
                    end: () => `top center+=${5 - delay}%`, // 延迟计算结束点
                    scrub: true, // 平滑过渡
                },
            },
        );
    });
}
